import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import store from "./app/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ToastContainer
        autoClose={3000}
        position="top-center"
        newestOnTop={true}
        theme="light"
        hideProgressBar={true}
        rtl={false}
      />
      <App />
    </Provider>
  </BrowserRouter>
);
reportWebVitals();
